<template>
  <div>
    <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="120">
      <Row type="flex" justify="center">
        <Col span="18">
          <FormItem label="物品名称" prop="name">
            <Input class="widK" v-model.trim="formValidate.name" placeholder="物品名称" />
          </FormItem>
          <FormItem label="积分值" prop="integralBranch">
            <Input class="widK" v-model.trim="formValidate.integralBranch" placeholder="积分值" />
          </FormItem>
          <FormItem label="总数量" prop="totalQuantity">
            <Input class="widK" v-model.trim="formValidate.totalQuantity" placeholder="总数量" />
          </FormItem>
        </Col>
      </Row>
      <Row type="flex" justify="center">
        <Button type="primary" @click="submit">确定</Button>
        <Button type="default" style="margin:0 16px" @click="handleReset">重置</Button>
        <Button type="default" @click="back">返回</Button>
      </Row>
    </Form>
  </div>
</template>

<script>
export default {
  name: "giftItemAdd",
  data() {
    const vn = (r, v, cb) => { if (!v) { cb(new Error("请输入值")); return; } if (!/^\d+$/.test(v)) { cb(new Error("请输入正整数")); return; } cb(); };
    return {
      formValidate: {},
      ruleValidate: {
        name: [{ required: true, message: "请填写物品名称", trigger: "blur" }],
        integralBranch: [{ required: true, validator: vn }],
        totalQuantity: [{ required: true, validator: vn }],
      },
    };
  },
  methods: {
    submit() {
      this.$refs.formValidate.validate(v => {
        if (!v) return;
        this.$http.post("/api/tGiftItem/save", JSON.parse(JSON.stringify(this.formValidate))).then(() => { this.$Message.success("保存成功"); this.back(); });
      });
    },
    handleReset() { this.$refs.formValidate.resetFields(); },
    back() { this.$store.commit("app/closePage", { vm: this, fromName: this.$route.name, toName: "giftItem" }); },
  },
};
</script>
<style scoped>#content { width: 100%; }</style>
